import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil, resetRecoil } from "recoil-nexus";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import LogController from "../../controller/LogController";
import { authState } from "../../recoil/auth";
import { eventState, EventStateType } from "../../recoil/event";
import { langState, langText } from "../../recoil/lang";

let timer: any;

const boxList = [
  {
    type: "between",
    list: [
      { img: "randomBox_luckyDraw", id: 0 },
      { img: "randomBox_luckyDraw", id: 1 },
      { img: "randomBox_luckyDraw", id: 2 },
    ],
  },
  {
    type: "center",
    list: [
      { img: "randomBox_luckyDraw", id: 3 },
      { img: "randomBox_luckyDraw", id: 4 },
    ],
  },
];

const RandomBoxNewYear = () => {
  const lang = useRecoilValue<number>(langState);
  const [event, setEvent] = useRecoilState<EventStateType>(eventState);

  const [isStart, setIsStart] = useState<boolean>(false);
  const [selectedBox, setSelectedBox] = useState<number>(-1);
  const [animationStatus, setAnimationStatus] = useState<number>(0);

  // API 이벤트 쿠폰 발급
  const setEventCoupon = async () => {
    try {
      if (event.event_id) {
        const response = await ApiController.store.setEventCoupon(
          event.event_id,
          getRecoil(authState).user_id,
          getRecoil(authState).user_token_id
        );

        if (response && response.data) {
          const oRes = response.data;
          if (oRes && oRes.success) {
            setEvent({
              ...event,
              coupon: oRes.coupon,
            });
            LogController.click({
              path: "RandomBoxNewYear",
              params: "event",
              params2:
                event.event_name +
                "선물상자 이벤트 당첨 (금액:" +
                response.data.coupon.price +
                ")",
              index: event.event_id,
            });
          }
        }
        setAnimationStatus(2);
        setIsStart(false);
        clearTimeout(timer);
      }
    } catch (err) {
      console.log("setEventCoupon err-->", err);
    }
  };

  const openBoxAnimation = (index: number) => {
    console.log("aniSta", animationStatus);
    if (animationStatus === 0) {
      setSelectedBox(index);
      setAnimationStatus(1);
      timer = setTimeout(() => {
        setEventCoupon();
      }, 800);
    }
  };

  const onCloseModal = () => {
    resetRecoil(eventState);
  };

  const startOrReset = () => {
    clearTimeout(timer);
    setAnimationStatus(0);
    setSelectedBox(-1);
    if (isStart) {
      setIsStart(false);
    } else {
      setIsStart(true);
    }
  };

  useEffect(() => {
    setIsStart(true);
  }, []);

  return (
    <Style>
      {animationStatus === 2 && (
        <div className="overlay">
          <div className="commentWrap">
            <h3>{langText.random_box_coupon_comment[lang]}</h3>
          </div>
          <button onClick={onCloseModal}>
            <h2>{langText.random_box_coupon_button[lang]}</h2>
          </button>
        </div>
      )}
      <div className="modal">
        <div className="titleWrap">
          <h1>{langText.random_box_title[lang]}</h1>
          <h2>{langText.random_box_subtitle[lang]}</h2>
          <div className="commentBox">
            <h3>{langText.random_box_comment[lang]}</h3>
          </div>
          <h4>{langText.random_box_sub_comment[lang]}</h4>
        </div>
        <div className="boxWrap">
          {boxList.map((box, index) => (
            <div key={index} className={`row ${box.type}`}>
              {box.list.map((item, boxIndex) => (
                <div
                  key={boxIndex}
                  className={`box ${
                    isStart && animationStatus === 0 && "start"
                  } ${selectedBox === item.id && "select"} ${
                    selectedBox === item.id &&
                    animationStatus === 1 &&
                    "shaking"
                  }`}
                  onClick={() => openBoxAnimation(item.id)}
                >
                  <img
                    className={`${
                      selectedBox === item.id && animationStatus === 2
                        ? "open"
                        : ""
                    }`}
                    src={`${process.env.PUBLIC_URL}/knockknock/img/newYear/${
                      item.img
                    }${
                      selectedBox === item.id && animationStatus === 2 ? "" : ""
                    }.png`}
                    alt="box"
                  />
                  {animationStatus === 2 && event.coupon && (
                    <div className="coupon">
                      <h2>{event.coupon.coupon_name}</h2>
                      <h3>{langText.coupon_won[lang]}🎉</h3>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
        {/* <button onClick={startOrReset}>{isStart ? "RESET" : "START"}</button> */}
      </div>
    </Style>
  );
};
export default RandomBoxNewYear;

const Style = styled.div`
  @font-face {
    font-family: "Jalnan2TTF";
    src: url("${process.env.PUBLIC_URL}/knockknock/font/Jalnan2TTF.ttf")
      format("truetype");
    font-weight: 400;
  }

  @keyframes vibration {
    from {
      transform: rotate(4deg);
    }
    to {
      transform: rotate(-4deg);
    }
  }

  @keyframes BigVibration {
    0% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(-10deg);
    }
    100% {
      transform: rotate(10deg);
    }
  }

  @keyframes showing {
    from {
      transform: translate(-50%, 30%) scale(0.5);
    }
    to {
      transform: translateY(-50%, -30%) scale(1);
    }
  }

  .modal {
    padding: 20% 5% 0 5%;
    width: 95vw;
    height: 95vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 36px;
    background-image: url("/knockknock/img/newYear/random_box_background.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
    display: flex;
    justify-content: center;

    .commentWrap {
      position: absolute;
      top: 35%;
      padding: 4px 30px;
      border-radius: 10px;
      background: #fae4c0;
      gap: 14px;
      z-index: 3;
      h3 {
        font-size: 20px;
        line-height: 36px;
        font-weight: 600;
        color: #e43c26;
      }
    }

    button {
      position: absolute;
      bottom: 6%;
      margin-top: auto;
      background: #fff;
      border-radius: 100px;
      padding: 12px 40px 6px 40px;

      h2 {
        font-size: 40px;
        line-height: 60px;
        font-family: "Jalnan2TTF";
        color: #ee6e3e;
      }
    }
  }

  img.title {
    width: 70%;
  }
  .titleWrap {
    text-align: center;
    h1,
    h2,
    h3 {
      font-family: "Jalnan2TTF";
      color: #e43c26;
      font-weight: 400;
    }
    h1 {
      font-size: 40px;
      line-height: 60px;
    }
    h2 {
      font-size: 78px;
      line-height: 117px;
    }
    h3 {
      font-size: 24px;
      color: #fff;
    }
    h4 {
      font-size: 20px;
      line-height: 28px;
      color: #9c4136;
    }
  }
  .commentBox {
    display: inline-block;
    margin: 11px 0 40px 0;
    padding: 16px 40px 8px 40px;
    border-radius: 50px;
    background: #ee6e3e;
  }

  h1 {
    font-size: 40px;
    line-height: 58px;
    font-weight: 700;
  }
  h3 {
    font-size: 20px;
    line-height: 26px;
    font-weight: 400;
    text-align: center;
  }

  .boxWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    margin-top: 60px;
  }
  .row {
    width: 100%;
    display: flex;
    align-items: flex-end;
  }
  .row.center {
    justify-content: center;
  }
  .row.between {
    justify-content: space-between;
  }

  .box {
    width: 180px;
    position: relative;
    display: flex;
    justify-content: center;
    transform-origin: center;
    img {
      width: 80%;
      margin-bottom: 50px;
    }
    img.open {
    }
    .coupon {
      display: none;
    }
  }
  .box.select {
    z-index: 2;
    .coupon {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -30%) scale(1);
      transform-origin: center;
      width: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      background: #00000080;
      padding: 10px 20px;
      scale: 1;
      animation: showing 0.2s ease-in-out;
      z-index: 2;
      h2 {
        line-height: 30px;
        color: #fff;
        font-weight: 700;
        white-space: nowrap;
      }
      h3 {
        font-size: 18px;
        line-height: 24px;
        font-weight: 500;
        white-space: nowrap;
        color: #fff;
      }
    }
  }
  .box.start {
    transform: translateX(0);
    transition: transform 0.5s ease-in;
    animation: BigVibration 2s infinite;
  }
  .box.shaking {
    animation: vibration 0.15s infinite;
  }

  button {
    z-index: 100;
    padding: 30px;
    border-radius: 10px;
    background: #fff;
    font-size: 24px;
  }
`;
